import { Grid } from '@mui/material';

import { disabledFutureDate } from '../../../../../../../helpers';
import { FormPhoneField, FormRadioGroupField } from '../../../../../common';
import { FormCheckboxField, FormDateField, FormTextField } from '../../../../../../common';
import { POLICYHOLDER_GENDER_OPTIONS } from '../constants';

import type { PolicyholderIdentityFieldsProps } from './types';

export default function PolicyholderIdentityFields({
  formik,
  disabled,
  saveFieldOnBlur,
  handleSameAsMemberChange,
}: PolicyholderIdentityFieldsProps) {
  return (
    <>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Policyholder first name"
          name="policyholder_first_name"
          onBlur={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Policyholder last name"
          name="policyholder_last_name"
          onBlur={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDateField
          disabled={disabled}
          disabledDate={disabledFutureDate}
          formik={formik}
          label="Policyholder date of birth"
          name="policyholder_date_of_birth"
          onChange={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormPhoneField
          disabled={disabled}
          formik={formik}
          label="Policyholder phone"
          name="policyholder_phone"
          onBlur={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormRadioGroupField
          disabled={disabled}
          formik={formik}
          label="Policyholder gender"
          name="policyholder_gender"
          onChange={saveFieldOnBlur}
          options={POLICYHOLDER_GENDER_OPTIONS}
          required
        />
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1 }}>
        <FormCheckboxField
          disabled={disabled}
          formik={formik}
          label="Policyholder address same as member"
          name="policyholder_address_same_as_member"
          onChange={handleSameAsMemberChange}
        />
      </Grid>
    </>
  );
}
